export const about = {
  hero: {
    title: 'Kuhusu BridgeCore empowermennt initiative',
    subtitle: 'Kwa zaidi ya miaka 8, BridgeCore empowermennt initiative imekuwa mwanga wa matumaini kwa wakimbizi na jamii zilizo hatarini nchini Jamhuri ya Kidemokrasia ya Kongo. Tunaamini kila mtu anastahili heshima, usalama, na fursa ya kujenga upya maisha yao kwa matumaini na kusudi.',
    stats: {
      yearsOfService: 'Miaka ya Huduma',
      livesImpacted: 'Maisha Yaliyoathiriwa',
      activeProjects: 'Miradi Inayoendelea',
      teamMembers: 'Wanachama wa Timu',
    },
  },
  mission: {
    badge: 'Dhamira Yetu',
    text: 'Kutoa msaada wa dharura, huduma za afya, elimu, na suluhisho endelevu zinazorejesha heshima na matumaini kwa wakimbizi na jamii zilizo hatarini Uganda.',
    teamMembers: 'Wanachama wa Timu Waliojitolea',
    volunteers: 'Wajitoleaji Hai',
    visionTitle: 'Maono Yetu',
    visionText: 'Mustakabali ambapo kila mkimbizi na mtu aliyehamishwa Uganda ana upatikanaji wa huduma muhimu, elimu, na fursa za kujenga upya maisha yao kwa heshima na matumaini.',
    valuesTitle: 'Maadili Yetu',
    values: {
      compassion: 'Huruma na Heshima',
      transparency: 'Uwazi na Uwajibikaji',
      empowerment: 'Uwezeshaji wa Jamii',
    },
  },
  team: {
    title: 'Kutana na Timu Yetu ya Uongozi',
    subtitle: 'Wataalamu waliojitolea waliojitolea kufanya athari ya kudumu katika maisha ya wakimbizi na jamii zilizo hatarini.',
  },
  partners: {
    title: 'Washirika Wetu',
    subtitle: 'Kufanya kazi pamoja na mashirika ya kimataifa na jamii za ndani ili kuongeza athari na kufikia.',
    achievementsTitle: 'Mafanikio Muhimu',
    achievementsSubtitle: 'Hatua muhimu zinazonyesha kujitolea kwetu na athari',
    awards: {
      humanitarian: {
        title: 'Tuzo ya Kibinadamu 2023',
        description: 'Kutambuliwa kwa huduma bora kwa jamii za wakimbizi',
      },
      certified: {
        title: 'NGO Iliyoidhinishwa',
        description: 'Imeidhinishwa kikamilifu na viwango vya kibinadamu vya kimataifa',
      },
      rating: {
        title: 'Ukadiriaji wa Nyota 5',
        description: 'Imepewa alama ya juu kwa uwazi na ufanisi wa athari',
      },
    },
  },
  volunteer: {
    title: 'Kuwa Mjitoleaji',
    subtitle: 'Jiunge na timu yetu na ufanye athari ya moja kwa moja katika maisha ya wakimbizi na jamii zilizo hatarini.',
  },
};
